import React, { useState } from "react";
import { Helmet } from "react-helmet";
import FsLightbox from "fslightbox-react";
import "../../../App.css"
import image1 from "../../../Img/Proyectos/ProyectosCasasDescanso/CasaOsoGrande/61ce6529b2978c576b5cba31_1.jpg"
import image2 from "../../../Img/Proyectos/ProyectosCasasDescanso/CasaOsoGrande/61ce6540a77d74778c875364_2.jpg"
import image3 from "../../../Img/Proyectos/ProyectosCasasDescanso/CasaOsoGrande/61ce655857f5523213a06e5e_3.jpg"
import image4 from "../../../Img/Proyectos/ProyectosCasasDescanso/CasaOsoGrande/61ce6558ad99f35f00bc1b01_4.jpg"
import image5 from "../../../Img/Proyectos/ProyectosCasasDescanso/CasaOsoGrande/61ce6558d9b077c8f7152c8b_5.jpg"
import image6 from "../../../Img/Proyectos/ProyectosCasasDescanso/CasaOsoGrande/61ce6557f9e0cab7e88b6cd7_6.jpg"
import image7 from "../../../Img/Proyectos/ProyectosCasasDescanso/CasaOsoGrande/61ce6557ad99f37104bc1b00_7.jpg"
import image8 from "../../../Img/Proyectos/ProyectosCasasDescanso/CasaOsoGrande/61ce6557c827903df10a1768_8.jpg"

function ProyectoCasaOsoGrande() {

    const [toggler, setToggler] = useState(false);

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    }


    return (
        <>

            <Helmet>
                <title>Playa y Montaña - Casa Oso Grande</title>
            </Helmet>

            <div className="container col-12 py-5">
                <div className="d-flex">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/proyectos-casas-de-descanso">Playa y Montaña</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Casa Oso Grande</li>
                        </ol>
                    </nav>
                </div>
                <h1 className="py-2 m-0 p-0">Casa Oso Grande</h1>
                <h6 className="py-2 m-0 p-0">Chacala, Nay.<h6>2007</h6></h6>
            </div>

            <FsLightbox
                toggler={lightboxController.toggler}

                sources={[
                    image1, image2, image3, image4, image5, image6, image7, image8
                ]}

                slide={lightboxController.slide}
            />

            <div className="container position-relative">
                <img onClick={() => openLightboxOnSlide(1)} type="button" src={image1} className="w-100" alt="..." height={650} />
            </div>


            <div className="container">
                <div className="row gy-4 mt-1">

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(2)}
                            src={image2}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(3)}
                            src={image3}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(4)}
                            src={image4}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(5)}
                            src={image5}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(6)}
                            src={image6}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(7)}
                            src={image7}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(8)}
                            src={image8}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                </div>
            </div>
        </>
    );
}

export default ProyectoCasaOsoGrande;
